import { render, staticRenderFns } from "./GerenciaRelatorioQuadroHorario.vue?vue&type=template&id=4934f1f1&scoped=true"
import script from "./GerenciaRelatorioQuadroHorario.vue?vue&type=script&lang=js"
export * from "./GerenciaRelatorioQuadroHorario.vue?vue&type=script&lang=js"
import style0 from "./GerenciaRelatorioQuadroHorario.vue?vue&type=style&index=0&id=4934f1f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4934f1f1",
  null
  
)

export default component.exports